import { ListChecks } from 'lucide-react';
import { Link, useSearchParams } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { PageHeader } from '@/components/ui/PageHeader';

import { JobsKpiHeader } from './components/JobsKpiHeader';
import { JobsTabela } from './components/JobsTabela';

/**
 * Página dedicada à fila de jobs do autenticador (carga de processo,
 * download de documento, peticionamento). Antes era uma aba dentro de
 * Integrações, mas o conteúdo é puramente operacional — mesma natureza
 * de Outbox e Fila de Emails — e não compartilha contexto visual com
 * o snapshot de saúde dos alvos externos.
 *
 * <p>Aceita deep-link `?alvo=` para drill-in vindo do card "Pipeline
 * interna" ou da sheet de detalhe de alvo.
 */
export default function JobsPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const alvoFiltro = searchParams.get('alvo');

  const limparFiltroAlvo = () => {
    const params = new URLSearchParams(searchParams);
    params.delete('alvo');
    setSearchParams(params, { replace: true });
  };

  return (
    <div className="space-y-6">
      <PageHeader
        icon={<ListChecks className="size-6" />}
        title="Jobs do autenticador"
        subtitle="Filas de carga de processo, download de documento e peticionamento. Use para investigar por que um item específico falhou."
        actions={
          <Button variant="outline" size="sm" asChild>
            <Link to="/app/admin/monitoramento">Ver saúde da integração</Link>
          </Button>
        }
      />

      {alvoFiltro && (
        <div className="flex items-center gap-2 rounded border border-primary/40 bg-primary/5 px-3 py-2 text-xs">
          <span className="text-muted-foreground">Filtrado por alvo:</span>
          <span className="font-mono font-semibold">{alvoFiltro}</span>
          <Button
            type="button"
            variant="unstyled"
            onClick={limparFiltroAlvo}
            className="ml-auto h-auto rounded px-2 py-0.5 text-muted-foreground hover:bg-muted"
            aria-label="Remover filtro de alvo"
          >
            ×
          </Button>
        </div>
      )}

      <JobsKpiHeader />
      <JobsTabela alvo={alvoFiltro ?? undefined} />
    </div>
  );
}
